import { render } from '@testing-library/preact';
import { matchTranslationBundle } from '../UNSAFE_matchTranslationBundle';
import { RootEnvironmentProvider } from '../../UNSAFE_Environment';
import type { RootEnvironment } from '../../UNSAFE_Environment';
import { TabbableModeContext } from '../../hooks/UNSAFE_useTabbableMode';
import { JSXInternal } from 'preact/src/jsx';

export const setupTabbableComponent = async (
  component: JSXInternal.Element,
  isTabbable?: boolean
) => {
  const locale = matchTranslationBundle(['en'], new Set(['en-US', 'en']));
  const { default: translations } = await import(`../../resources/nls/${locale}/bundle.ts`);
  const env: Partial<RootEnvironment> = {
    translations: { '@oracle/oraclejet-preact': translations }
  };
  if (isTabbable !== undefined) {
    return render(
      <RootEnvironmentProvider environment={env}>
        <TabbableModeContext.Provider value={{ isTabbable: isTabbable }}>
          {component}
        </TabbableModeContext.Provider>
      </RootEnvironmentProvider>
    );
  } else {
    return render(<RootEnvironmentProvider environment={env}>{component}</RootEnvironmentProvider>);
  }
};
